import { render, staticRenderFns } from "./FirstStep.vue?vue&type=template&id=00aeb134&scoped=true"
import script from "./FirstStep.vue?vue&type=script&lang=js"
export * from "./FirstStep.vue?vue&type=script&lang=js"
import style0 from "./FirstStep.vue?vue&type=style&index=0&id=00aeb134&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00aeb134",
  null
  
)

export default component.exports